import {Alert, Card, CardBody, CardHeader, FormSelect} from "shards-react";
import React from "react";

function AdminBand({users, activeUser, onChange}){

  //console.log("AdminBanner ", users, activeUser)
  if (users.length > 0) {
    return (
      <Card small className="mb-4 pt-3">
        <CardHeader className="border-bottom text-center">
          <Alert theme="danger">{`Estas registrado como admin`}</Alert>
        </CardHeader>
        <CardBody>
          <FormSelect onChange={onChange} defaultValue={activeUser.username}>
            {
              users.map((value, index) => (
                <option value={value.username} key={`option-user-${index}`}>{value.username}</option>
              ))

            }
          </FormSelect>
        </CardBody>
      </Card>
    )

  }else{
    //console.log("Admin Band Null");
    return null
  }
}

export {AdminBand}
